import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "sonner";
import { backend } from "../../services/backend";
import { RootState, actions } from "../../state/reducer";
import { formatPhoneNumber, isValidEmail } from "../../utils";

const LoginForm = (props?: { isSignup: boolean; link?: string }) => {
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const isSignup = props?.isSignup;
  const [stage, setStage] = useState<"email" | "password">("email");
  const [isPending, Pending] = useState(false);
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [entryError, setEntryError] = useState<string>("");
  const [passwordToConfirm, setPasswordToconfirm] = useState<string>("");

  const signinAction = (email, password) => {
    if (!isValidEmail(email)) {
      setEntryError("Неверный адрес электронной почты");
      return;
    }
    backend
      .signin({
        email,
        password,
      })
      .then((result) => {
        toast("Вы успешно авторизованы, перенаправляем");
        dispatch(actions.saveSession(result));
        document.location.pathname = "/";
        console.log(result);
      })
      .catch((err) => {
        toast("Неверный пароль");
      })
      .finally(() => {
        Pending(false);
      });
  };

  const signupAction = (email: string, password: string) => {
    if (password !== passwordToConfirm) {
      toast("Пароли не совпадают");
      Pending(false);
      return;
    }

    if (!name || !phone || !email) {
      toast("Обязательны к заполнению имя, телефон, email");
      Pending(false);
      return;
    }

    if (!props?.link) return;
    backend
      .signup({
        link: props.link,
        email: email?.toLowerCase(),
        password,
        personal: {
          first_name: name,
          phone: formatPhoneNumber(phone),
        },
      })
      .then((result) => {
        toast("Письмо для подтверждения выслано на емейл");
        backend
          .requestEmailConfirm(result.id)
          .then((res) => {
            console.log(res);
            document.location.href = "/";
            Pending(false);
          })
          .catch((e) => {
            console.log(e);
            Pending(false);
          });
      })
      .catch((err) => {
        alert(err);
      });
  };

  const formPassHandler = () => {
    if (isPending) return;
    if (stage === "email" && email) {
      if (isSignup) {
        if (!name || !phone || !email) {
          toast("Обязательны к заполнению имя, телефон, email");
          Pending(false);
          return;
        }
      }
      setStage("password");
    } else {
      if (!password || !email) return;
      Pending(true);
      if (!props?.isSignup) {
        signinAction(email?.toLowerCase(), password);
        return;
      } else {
        signupAction(email?.toLowerCase(), password);
      }
    }
  };

  return (
    <div className="loginform">
      <div className="loginFormHeading">
        <h3 className="heading3">
          {props && isSignup ? "Регистрация" : "Авторизация"}
        </h3>
      </div>
      <div className="loginFormInner">
        {stage === "email" ? (
          <>
            {isSignup && (
              <>
                <div className="fieldName">Имя:</div>
                <div className="field">
                  <input
                    type="text"
                    name="name"
                    value={name}
                    onChange={(event: any) => {
                      const name = String(event.target.value);
                      setName(name);
                    }}
                  />
                </div>
                <div className="fieldName">Телефон:</div>
                <div className="field">
                  <input
                    type="text"
                    name="phone"
                    value={phone}
                    onChange={(event: any) => {
                      const phone = String(event.target.value);
                      backend
                        .checkDataHold({ phone })
                        .then((res) => {
                          if (res.hold) {
                            toast(
                              "Пользователь с таким номером телефона уже есть"
                            );
                          }
                        })
                        .catch((e) => {
                          toast("не удалось проверить, занят ли адрес");
                        });
                      setPhone(phone);
                    }}
                  />
                </div>
              </>
            )}
            <div className="fieldName">Email:</div>
            <div className="field">
              <input
                type="text"
                name="email"
                autoComplete="email"
                value={email}
                onChange={(event: any) => {
                  const email = String(event.target.value);
                  if (email && email.length > 3) {
                    if (isSignup)
                      backend
                        .checkDataHold({ email })
                        .then((res) => {
                          if (res.hold) {
                            toast("Пользователь с таким адресом уже есть");
                          }
                        })
                        .catch((e) => {
                          toast("не удалось проверить, занят ли адрес");
                        });
                  }
                  setEmail(email);
                }}
              />
            </div>
          </>
        ) : (
          <>
            <div className="fieldName">Введите пароль:</div>
            <div className="field">
              <input
                type="password"
                name="password"
                autoComplete={!props?.isSignup ? "new-password" : "password"}
                value={password}
                onChange={(event: any) => setPassword(event.target.value)}
              />
            </div>
            {props && props.isSignup ? (
              <>
                <div className="fieldName">Подтвердите пароль:</div>
                <div className="field">
                  <input
                    type="password"
                    name="password-confirm"
                    autoComplete="password-confirm"
                    value={passwordToConfirm}
                    onChange={(event: any) =>
                      setPasswordToconfirm(event.target.value)
                    }
                  />
                </div>
              </>
            ) : null}
          </>
        )}
      </div>
      <div
        className={`btn loginActionButton${isPending ? " disabled" : ""}`}
        onClick={formPassHandler}
      >
        {props?.isSignup
          ? stage === "email"
            ? "Далее"
            : "Зарегистрироваться"
          : "Войти"}
      </div>
      {!props?.isSignup && stage === "password" ? (
        <div className="btnContainer">
          <a className="textBtn passwordRecover" href="/recover">
            Восстановить пароль
          </a>
        </div>
      ) : null}
      {/* <div className="loginFormDivider">или</div>
      <div className="externalAuthBlock">Продолжить с Google</div> */}
    </div>
  );
};

export default LoginForm;
